import { useGtag } from "vue-gtag-next";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { isAndroid } from "@/apps/credit-line/helpers/platformChecker.helper";
import { Service } from "@/apps/credit-line/services/network.service";

const CreditLineService = new Service();

export const coreAppOnboardingCategoryName = "CoreAppOnboarding";

const getHostname = (): string => {
  try {
    return window?.location?.hostname ?? "";
  } catch {
    return "";
  }
};

export const logAnalyticsEvent = (
  name: string,
  category: string,
  label?: string,
  data?: Record<string, string | number | boolean | null | undefined>,
  callback?: (x: unknown) => void
): void => {
  const deviceIdentifier = AuthenticationHelper.getDeviceTag();
  const hostname = getHostname();

  if (deviceIdentifier != "") {
    if (isAndroid()) {
      const googleEventData = {
        event_category: category,
        event_label: label,
        engagement_time_msec: 1,
        deviceTag: deviceIdentifier,
        hostname,
        ...data,
      };
      const { event } = useGtag();
      event(name, googleEventData);
    }
    CreditLineService.logEvent({
      logData: {
        event: name,
        deviceTag: deviceIdentifier,
        additionalData: { data, label, hostname },
      },
      deviceTag: deviceIdentifier,
    })
      .then((res) => {
        if (callback) {
          callback(res);
        }
      })
      .catch((error) => {
        console.log("log error", error);
      })
      .finally(() => {
        if (callback) {
          callback(undefined);
        }
      });
  }
};

export default logAnalyticsEvent;
